const columns = [
  {
    name: 'Nome',
    key: 'name',
  },
  {
    name: 'E-mail',
    key: 'email1',
  },
  {
    name: 'Empresa Vinculada',
    key: 'companyName',
  },
  {
    name: 'Ações',
    key: 'actions',
  },
];

export default columns;
